/**
 * @generated SignedSource<<faae944eea0ed1b9362e109484431a19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfTopicsElementFragment$data = {
  readonly topics: ReadonlyArray<{
    readonly hidden: boolean | null | undefined;
    readonly items: ReadonlyArray<{
      readonly __typename: "HelpLayoutTopicItem";
    }> | null | undefined;
    readonly topicId: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"topicCardFragment">;
  }> | null | undefined;
  readonly visualConfig: {
    readonly titleColor: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "listOfTopicsElementFragment";
};
export type listOfTopicsElementFragment$key = {
  readonly " $data"?: listOfTopicsElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfTopicsElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOfTopicsElementFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "topicId"
        },
        {
          "kind": "ScalarField",
          "name": "hidden"
        },
        {
          "concreteType": "HelpLayoutTopicItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "topicCardFragment"
        }
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "titleColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutTopicsListElement"
};

(node as any).hash = "00ae89e8e25628e5539a71375e02d691";

export default node;
